import { FC, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { getInitials } from '@repo/shared';

import { CustomerListResponseOutputItemsItem } from '@/api/generated';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { CompletionIndicator } from '@/components/ui/completion-indicator';
import { TableCell, TableRow } from '@/components/ui/table';

interface CustomerRowProps {
  customer: CustomerListResponseOutputItemsItem;
  completionRate: number;
  hasHighPending: boolean;
  pendingAnnotations: number;
  totalItems: number;
  onSelectCustomer: (customerId: number) => void;
}

export const CustomersTableRow: FC<CustomerRowProps> = ({
  customer,
  completionRate,
  pendingAnnotations,
  totalItems,
  onSelectCustomer,
}: CustomerRowProps) => {
  const initials = useMemo(
    () => getInitials(customer.displayName),
    [customer.displayName]
  );

  return (
    <TableRow
      onClick={() => {
        onSelectCustomer(customer.id);
      }}>
      <TableCell className='flex flex-center gap-3'>
        <Avatar>
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div>
          <Trans
            i18nKey='customers.table.displayName'
            values={{ name: customer.displayName, id: customer.id }}
            components={{
              name: (
                <p className='text-primary text-xs font-bold transition-colors' />
              ),
              id: <p className='text-muted-foreground font-mono text-[10px]' />,
            }}
          />
        </div>
      </TableCell>
      <TableCell>{totalItems.toLocaleString()}</TableCell>
      <TableCell>
        <span>{pendingAnnotations.toLocaleString()}</span>
      </TableCell>
      <TableCell>
        <span className='text-muted-foreground font-mono text-[10px] font-semibold'>
          <Trans
            i18nKey='customers.completionDone'
            values={{ rate: completionRate }}
          />
        </span>
        <CompletionIndicator rate={completionRate} />
      </TableCell>
    </TableRow>
  );
};
